

import { Truck } from '@/types';
import { 
  createGenericColumns, 
  createCurrencyCell, 
  createDateCell, 
  createBooleanBadgeCell,
  GenericColumnConfig 
} from '@/shared/components/GenericTableColumns';

/**
 * トラックテーブルのカラム設定
 */
const trucksColumnConfigs: GenericColumnConfig<Truck>[] = [
  {
    accessorKey: 'name',
    header: 'トラック名',
    sortable: true,
    size: 200,
    cell: (value) => <div className="font-medium">{value}</div>,
  },
  {
    accessorKey: 'truck_type',
    header: 'トラック種別',
    sortable: true,
    size: 150,
    cell: (value) => value || '-',
  },
  {
    accessorKey: 'daily_cost',
    header: '日あたりコスト (円)',
    sortable: true,
    headerAlign: 'right',
    cellAlign: 'right',
    size: 120,
    cell: createCurrencyCell,
  },
  {
    accessorKey: 'is_active',
    header: '有効状態',
    sortable: true,
    size: 100,
    cell: createBooleanBadgeCell('有効', '無効', 'default', 'destructive'),
  },
  {
    accessorKey: 'created_at',
    header: '登録日時',
    sortable: true,
    size: 150,
    cell: createDateCell,
  },
];

/**
 * トラックマスタデータのカラム定義 (Generic版)
 * 元のcolumns.tsxを置き換える改良版
 */
export const columns = createGenericColumns<Truck>(
  trucksColumnConfigs,
  {
    showSelect: true,
    actionMenu: {
      showCopyId: true,
      items: [
        {
          label: '編集',
          onClick: (truck) => {
            // 編集処理は親コンポーネントで実装される
            console.log('Edit truck:', truck.id);
          },
        },
        {
          label: '削除',
          onClick: (truck) => {
            // 削除処理は親コンポーネントで実装される
            console.log('Delete truck:', truck.id);
          },
          variant: 'destructive',
          show: (truck) => !truck.is_active, // 無効なトラックのみ削除可能
        },
      ],
    },
  }
);

/**
 * カスタムアクションメニュー付きカラムを生成する関数
 */
export function createTrucksColumns(actions?: {
  onEdit?: (truck: Truck) => void;
  onDelete?: (truck: Truck) => void;
}) {
  return createGenericColumns<Truck>(
    trucksColumnConfigs,
    {
      showSelect: true,
      actionMenu: {
        showCopyId: true,
        items: [
          ...(actions?.onEdit ? [{
            label: '編集',
            onClick: actions.onEdit,
          }] : []),
          ...(actions?.onDelete ? [{
            label: '削除',
            onClick: actions.onDelete,
            variant: 'destructive' as const,
            show: (truck: Truck) => !truck.is_active,
          }] : []),
        ],
      },
    }
  );
}